import { DateString, dateStringSerializer, Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";
import Decimal from "decimal.js";

import { currencies, Currency } from "../common";
import { OrderStatus, orderStatuses } from "./orderStatus";

export type OrderSimpleDto = {
  uuid: Uuid;
  referenceNumber: string;
  sellToCustomerUuid: Uuid | null;
  billToCustomerUuid: Uuid | null;
  currency: Currency;
  orderDate: DateString;
  netTotal: Decimal;
  updatedAt: Date;
  placedAt: Date;
  status: OrderStatus;
};

export const orderSimpleDtoSerializer = MSerializers.object<OrderSimpleDto>({
  uuid: uuidSerializer,
  referenceNumber: MSerializers.string,
  sellToCustomerUuid: uuidSerializer.nullable(),
  billToCustomerUuid: uuidSerializer.nullable(),
  currency: MSerializers.stringOneOf(...currencies),
  netTotal: MSerializers.decimal,
  orderDate: dateStringSerializer,
  updatedAt: MSerializers.datetime,
  placedAt: MSerializers.datetime,
  status: MSerializers.stringOneOf(...orderStatuses),
});
